// extracted by mini-css-extract-plugin
module.exports = {"end-game-img":"EndGameComponent_end-game-img__1xRum","end-game-root":"EndGameComponent_end-game-root__gcvlg","modal-btn":"EndGameComponent_modal-btn__OqxCQ"};